(function () {
  var configCache = {};
  var resolutionMap = {
    wrist_wraps: {
      questions: [
        "lifting_type",
        "maximal_lift_frequency",
        "primary_goal",
        "compound_lift_days",
        "training_intensity"
      ],
      values: [
        ["general_weightlifting", "moderate_strength_training", "powerlifting_strongman"],
        ["rarely", "occasionally", "frequently"],
        ["general_support", "additional_stability", "extreme_stability"],
        ["one_two_days", "three_four_days", "five_plus_days"],
        ["moderate_variety", "progressive_prs", "near_max_heavy"]
      ],
      scoreKey: "56867989b67978a9ac89b9acbce67978a9ac78a89babd9acabdcdf89b9acbce9acabdcdfbcecdfefh67978a9ac78a89babd9acabdcdf78a89babd89b9acbceabdbcedeg9acabdcdfabdbcedegcdfdegfgi89b9acbce9acabdcdfbcecdfefh9acabdcdfabdbcedegcdfdegfgibcecdfefhcdfdegfgiefhfgihik",
      resultKey: "000000000000000000000000001000000000000000000000000001000000001000000001001001111000000000000000000000000001000000000000000001000001011000000001000001011001011112000000001000000001001001111000000001000001011001011112001001111001011112111112122",
      resultIds: ["regular-16-overall", "stiff-16-support", "stiff-24-bench"]
    }
  };

  function loadConfig(url) {
    if (!url) {
      return Promise.reject(new Error("Recommendation config URL is missing."));
    }

    if (!configCache[url]) {
      configCache[url] = fetch(url, { credentials: "same-origin" }).then(function (response) {
        if (!response.ok) {
          throw new Error("Recommendation config failed to load.");
        }
        return response.json();
      });
    }

    return configCache[url];
  }

  function getSessionId() {
    var key = "tuff_recommendation_session";
    var id = "";

    try {
      id = window.localStorage.getItem(key);
      if (!id) {
        id = String(Date.now()) + "-" + Math.random().toString(16).slice(2);
        window.localStorage.setItem(key, id);
      }
    } catch (error) {
      id = String(Date.now()) + "-" + Math.random().toString(16).slice(2);
    }

    return id;
  }

  function siblingEndpoint(url, endpoint) {
    if (!url) {
      return "";
    }

    return url.replace(/\/recommend\/?(\?.*)?$/, "/" + endpoint);
  }

  function trackEvent(root, eventType, details) {
    var apiUrl = root.getAttribute("data-api-url");
    var trackUrl = siblingEndpoint(apiUrl, "track");
    var payload = Object.assign({
      eventType: eventType,
      sessionId: getSessionId(),
      flowId: root.getAttribute("data-recommendation-flow") || "wrist_wraps",
      recommendationId: root.getAttribute("data-current-recommendation-id") || "",
      pagePath: window.location.pathname
    }, details || {});

    if (!trackUrl) {
      return Promise.resolve();
    }

    return fetch(trackUrl, {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "accept": "application/json",
        "content-type": "application/json"
      },
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  function loadServerRecommendation(url, flowId, answers, sessionId) {
    if (!url) {
      return Promise.reject(new Error("Recommendation API URL is missing."));
    }

    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "accept": "application/json",
        "content-type": "application/json"
      },
      body: JSON.stringify({
        flowId: flowId,
        answers: answers || {},
        sessionId: sessionId || getSessionId(),
        pagePath: window.location.pathname
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Recommendation API failed.");
      }

      return response.json();
    }).then(function (payload) {
      return payload && (payload.recommendation || payload);
    });
  }

  function resolveRecommendation(apiUrl, configUrl, flowId, answers, sessionId) {
    if (apiUrl) {
      return loadServerRecommendation(apiUrl, flowId, answers, sessionId).catch(function () {
        return loadConfig(configUrl).then(function (config) {
          return recommend(config, flowId, answers);
        });
      });
    }

    return loadConfig(configUrl).then(function (config) {
      return recommend(config, flowId, answers);
    });
  }

  function valueMatches(expected, actual) {
    if (Array.isArray(expected)) {
      return expected.indexOf(actual) !== -1;
    }

    return expected === actual;
  }

  function ruleMatches(rule, answers) {
    var when = rule.when || {};
    return Object.keys(when).every(function (key) {
      return valueMatches(when[key], answers[key]);
    });
  }

  function scoreRecommendation(recommendation, answers) {
    var score = Number(recommendation.baseScore || 0);

    (recommendation.rules || []).forEach(function (rule) {
      if (ruleMatches(rule, answers)) {
        score += Number(rule.score || 0);
      }
    });

    return score;
  }

  function getResolution(flowId, answers) {
    var spec = resolutionMap[flowId];
    var index = 0;

    if (!spec) {
      return null;
    }

    for (var i = 0; i < spec.questions.length; i += 1) {
      var value = answers ? answers[spec.questions[i]] : null;
      var optionIndex = spec.values[i].indexOf(value);

      if (optionIndex < 0) {
        return null;
      }

      index = (index * spec.values[i].length) + optionIndex;
    }

    var scoreChar = spec.scoreKey.charAt(index);
    var resultChar = spec.resultKey.charAt(index);
    var score = "0123456789abcdefghijklmnopqrstuv".indexOf(scoreChar);
    var resultIndex = Number(resultChar);
    var resultId = spec.resultIds[resultIndex];

    if (!resultId || score < 0) {
      return null;
    }

    return {
      score: score,
      resultId: resultId
    };
  }

  function scoreAnswers(flow, answers, flowId) {
    var resolved = getResolution(flowId, answers);

    if (resolved) {
      return resolved.score;
    }

    return 0;
  }

  function findRecommendationById(flow, recommendationId) {
    var recommendations = flow ? flow.recommendations || [] : [];
    return recommendations.filter(function (recommendation) {
      return recommendation.id === recommendationId;
    })[0] || null;
  }

  function recommendIndexed(flow, answers, flowId) {
    var resolved = getResolution(flowId, answers);
    var totalScore = resolved ? resolved.score : scoreAnswers(flow, answers, flowId);
    var recommendations = flow ? flow.recommendations || [] : [];
    var recommendation = resolved ? findRecommendationById(flow, resolved.resultId) : null;

    recommendation = recommendation || findRecommendationById(flow, flow && flow.defaultRecommendation) || recommendations[0];

    if (!recommendation) {
      return null;
    }

    return Object.assign({}, recommendation, { score: totalScore });
  }

  function getFlow(config, flowId) {
    if (!config || !config.flows) {
      return null;
    }

    return config.flows[flowId] || config.flows[Object.keys(config.flows)[0]];
  }

  function recommend(config, flowId, answers) {
    var flow = getFlow(config, flowId);
    var fallbackId = flow && flow.defaultRecommendation;
    var recommendations = flow ? flow.recommendations || [] : [];

    if (!recommendations.length) {
      return null;
    }

    if (flow.scoring && flow.scoring.type === "indexed") {
      return recommendIndexed(flow, answers, flowId);
    }

    return recommendations
      .map(function (recommendation, index) {
        return {
          recommendation: recommendation,
          index: index,
          score: scoreRecommendation(recommendation, answers)
        };
      })
      .sort(function (a, b) {
        if (b.score !== a.score) {
          return b.score - a.score;
        }

        if (a.recommendation.id === fallbackId) {
          return -1;
        }

        if (b.recommendation.id === fallbackId) {
          return 1;
        }

        return a.index - b.index;
      })[0].recommendation;
  }

  function setText(root, selector, value) {
    var el = root.querySelector(selector);
    if (el) {
      el.textContent = value || "";
    }
  }

  function setHref(root, selector, value) {
    var el = root.querySelector(selector);
    if (el && value) {
      el.href = value;
    }
  }

  function setImage(root, recommendation) {
    var image = root.querySelector("[data-result-image]");
    var imageLink = root.querySelector("[data-result-image-link]");

    if (!image || !recommendation || !recommendation.imageUrl) {
      if (imageLink) {
        imageLink.hidden = true;
      }
      return;
    }

    image.src = recommendation.imageUrl;
    image.alt = recommendation.imageAlt || recommendation.title || "";
    if (imageLink) {
      imageLink.href = recommendation.productUrl || recommendation.resultUrl || "#";
      imageLink.hidden = false;
    }
  }

  function renderList(root, selector, items) {
    var list = root.querySelector(selector);
    if (!list) {
      return;
    }

    list.innerHTML = "";
    (items || []).forEach(function (item) {
      var li = document.createElement("li");
      li.textContent = item;
      list.appendChild(li);
    });
  }

  function setDiscountMessage(form, text, state) {
    var message = form ? form.querySelector("[data-discount-message]") : null;
    if (!message) {
      return;
    }

    message.textContent = text || "";
    message.classList.toggle("is-success", state === "success");
    message.classList.toggle("is-error", state === "error");
  }

  function validEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || "");
  }

  function resetDiscountForm(root) {
    var form = root.querySelector("[data-recommender-discount-form]");
    if (!form) {
      return;
    }

    var input = form.querySelector("input[type='email']");
    var button = form.querySelector("button[type='submit']");
    if (input) {
      input.disabled = false;
      input.removeAttribute("aria-invalid");
    }
    if (button) {
      button.disabled = false;
      button.textContent = button.getAttribute("data-original-label") || button.textContent;
    }
    setDiscountMessage(form, "", "");
  }

  function updateDiscountForm(root, recommendation, answers) {
    var form = root.querySelector("[data-recommender-discount-form]");
    if (!form || !recommendation) {
      return;
    }

    form.setAttribute("data-recommendation-id", recommendation.id || "");
    form.setAttribute("data-recommendation-title", recommendation.title || "");
    form.setAttribute("data-recommendation-length", recommendation.length || "");
    form.setAttribute("data-recommendation-stiffness", recommendation.stiffness || "");
    form.setAttribute("data-recommendation-url", recommendation.productUrl || recommendation.resultUrl || "");
    form.setAttribute("data-quiz-score", typeof recommendation.score === "number" ? String(recommendation.score) : "");
    form.setAttribute("data-quiz-answers", JSON.stringify(answers || {}));
    resetDiscountForm(root);
  }

  function buildDiscountProperties(root, form) {
    var answers = {};

    try {
      answers = JSON.parse(form.getAttribute("data-quiz-answers") || "{}");
    } catch (error) {
      answers = {};
    }

    return {
      source: root.getAttribute("data-klaviyo-source") || "Find Your Wraps",
      quiz_type: root.getAttribute("data-recommendation-flow") || "wrist_wraps",
      took_quiz: true,
      took_wrist_wrap_quiz: true,
      last_quiz_taken: "Find Your Wraps",
      last_wrist_wrap_quiz_completed_at: new Date().toISOString(),
      quiz_score: form.getAttribute("data-quiz-score") || "",
      recommended_wrap: form.getAttribute("data-recommendation-title") || "",
      recommendation_id: form.getAttribute("data-recommendation-id") || "",
      recommended_length: form.getAttribute("data-recommendation-length") || "",
      recommended_support_feel: form.getAttribute("data-recommendation-stiffness") || "",
      recommended_product_url: form.getAttribute("data-recommendation-url") || "",
      lifting_type: answers.lifting_type || "",
      maximal_lift_frequency: answers.maximal_lift_frequency || "",
      primary_goal: answers.primary_goal || "",
      compound_lift_days: answers.compound_lift_days || "",
      training_intensity: answers.training_intensity || ""
    };
  }

  function bindDiscountSignup(root) {
    var form = root.querySelector("[data-recommender-discount-form]");
    if (!form || form.getAttribute("data-discount-ready") === "true") {
      return;
    }

    var button = form.querySelector("button[type='submit']");
    if (button) {
      button.setAttribute("data-original-label", button.textContent);
    }

    form.setAttribute("data-discount-ready", "true");
    form.addEventListener("submit", function (event) {
      event.preventDefault();

      var companyId = root.getAttribute("data-klaviyo-company-id") || "";
      var listId = root.getAttribute("data-klaviyo-list-id") || "";
      var source = root.getAttribute("data-klaviyo-source") || "Find Your Wraps";
      var input = form.querySelector("input[type='email']");
      var email = input ? input.value.trim() : "";

      if (!validEmail(email)) {
        if (input) {
          input.setAttribute("aria-invalid", "true");
          input.focus();
        }
        setDiscountMessage(form, "Enter a valid email address.", "error");
        return;
      }

      if (!companyId || !listId) {
        setDiscountMessage(form, "This signup is not connected yet.", "error");
        return;
      }

      if (button) {
        button.disabled = true;
        button.textContent = "Submitting...";
      }
      if (input) {
        input.removeAttribute("aria-invalid");
      }
      setDiscountMessage(form, "", "");

      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(companyId), {
        method: "POST",
        headers: {
          "accept": "application/vnd.api+json",
          "content-type": "application/vnd.api+json",
          "revision": "2026-04-15"
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    },
                    properties: buildDiscountProperties(root, form)
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: listId
                }
              }
            }
          }
        })
      }).then(function (response) {
        if (!response.ok && response.status !== 202) {
          throw new Error("Klaviyo subscription failed.");
        }

        if (input) {
          input.disabled = true;
        }
        if (button) {
          button.textContent = "Check Your Email";
        }
        setDiscountMessage(form, "You're in. Check your email for the discount.", "success");
        trackEvent(root, "discount_signup_success", {
          recommendationId: form.getAttribute("data-recommendation-id") || "",
          targetUrl: form.getAttribute("data-recommendation-url") || ""
        });
      }).catch(function () {
        if (button) {
          button.disabled = false;
          button.textContent = button.getAttribute("data-original-label") || "Get 10% Off";
        }
        setDiscountMessage(form, "Something went wrong. Try again in a moment.", "error");
        trackEvent(root, "discount_signup_error", {
          recommendationId: form.getAttribute("data-recommendation-id") || ""
        });
      });
    });
  }

  function bindResultTracking(root) {
    if (root.getAttribute("data-result-tracking-ready") === "true") {
      return;
    }

    root.setAttribute("data-result-tracking-ready", "true");
    var primary = root.querySelector("[data-result-primary]");
    var secondary = root.querySelector("[data-result-secondary]");
    var resultLink = root.querySelector("[data-result-url]");

    if (primary) {
      primary.addEventListener("click", function () {
        trackEvent(root, "shop_click", {
          targetUrl: primary.href
        });
      });
    }

    if (secondary) {
      secondary.addEventListener("click", function () {
        trackEvent(root, "compare_click", {
          targetUrl: secondary.href
        });
      });
    }

    if (resultLink) {
      resultLink.addEventListener("click", function () {
        trackEvent(root, "result_link_click", {
          targetUrl: resultLink.href
        });
      });
    }
  }

  function bindMobileStart(root) {
    var section = root.closest(".tuff-fit-finder") || document;
    var start = section.querySelector("[data-recommender-mobile-start]");
    if (!start || start.getAttribute("data-mobile-start-ready") === "true") {
      return;
    }

    if (!root.classList.contains("is-complete")) {
      root.classList.add("is-waiting-to-start");
    }

    start.setAttribute("data-mobile-start-ready", "true");
    start.addEventListener("click", function (event) {
      event.preventDefault();
      root.classList.remove("is-waiting-to-start");
      root.classList.add("is-started");
      if (section.classList) {
        section.classList.add("is-quiz-started");
      }
      trackEvent(root, "quiz_started");

      window.setTimeout(function () {
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 40);
    });
  }

  function compareTarget(root) {
    var section = root.closest(".tuff-fit-finder") || document;
    if (section.querySelector("#wrap-recommendations")) {
      return "#wrap-recommendations";
    }
    if (section.querySelector("#wrap-comparison")) {
      return "#wrap-comparison";
    }
    return "/collections/powerlifting-wrist-wraps";
  }

  function updateProgress(root, currentIndex, total, answers) {
    var current = currentIndex + 1;
    var answeredCount = Object.keys(answers || {}).length;
    var progressCount = Math.min(total, Math.max(current, answeredCount + 1));
    setText(root, "[data-progress-current]", String(current));
    setText(root, "[data-progress-total]", String(total));

    var bar = root.querySelector("[data-progress-bar]");
    if (bar) {
      bar.style.width = String((progressCount / total) * 100) + "%";
    }
  }

  function showStep(root, steps, index, answers) {
    steps.forEach(function (step, stepIndex) {
      var isActive = stepIndex === index;
      step.classList.toggle("is-active", isActive);
      step.toggleAttribute("hidden", !isActive);
    });

    var back = root.querySelector("[data-recommender-back]");
    if (back) {
      back.disabled = index === 0;
    }

    updateProgress(root, index, steps.length, answers);
  }

  function selectOption(step, value) {
    step.querySelectorAll("[data-answer-option]").forEach(function (button) {
      var isSelected = button.getAttribute("data-answer-value") === value;
      button.classList.toggle("is-selected", isSelected);
      button.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });
  }

  function renderResult(root, recommendation, answers) {
    if (!recommendation) {
      return;
    }

    root.setAttribute("data-current-recommendation-id", recommendation.id || "");
    setText(root, "[data-result-product]", recommendation.title);
    setText(root, "[data-result-length]", recommendation.length);
    setText(root, "[data-result-stiffness]", recommendation.stiffness);
    setText(root, "[data-result-explanation]", recommendation.summary);
    setHref(root, "[data-result-primary]", recommendation.productUrl);
    setHref(root, "[data-result-secondary]", compareTarget(root));
    setHref(root, "[data-result-url]", recommendation.resultUrl);
    setImage(root, recommendation);
    renderList(root, "[data-result-best-for]", recommendation.bestFor);
    updateDiscountForm(root, recommendation, answers);

    var result = root.querySelector("[data-recommendation-result]");
    updateProgress(root, root.querySelectorAll("[data-recommender-step]").length - 1, root.querySelectorAll("[data-recommender-step]").length, answers || {});
    if (result) {
      result.hidden = false;
      result.removeAttribute("aria-hidden");
      result.focus({ preventScroll: true });
    }
  }

  function initFinder(root) {
    if (!root || root.getAttribute("data-recommender-ready") === "true") {
      return;
    }

    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-recommender-step]"));
    if (!steps.length) {
      return;
    }

    var answers = {};
    var currentIndex = 0;
    var flowId = root.getAttribute("data-recommendation-flow") || "wrist_wraps";
    var configUrl = root.getAttribute("data-config-url");
    var apiUrl = root.getAttribute("data-api-url");
    var sessionId = getSessionId();
    var stepWrap = root.querySelector("[data-recommender-steps]");
    var result = root.querySelector("[data-recommendation-result]");

    root.setAttribute("data-recommender-ready", "true");
    bindMobileStart(root);
    bindDiscountSignup(root);
    bindResultTracking(root);
    showStep(root, steps, currentIndex, answers);

    root.querySelectorAll("[data-answer-option]").forEach(function (button) {
      button.addEventListener("click", function () {
        var step = button.closest("[data-recommender-step]");
        var questionId = step.getAttribute("data-question-id");
        var value = button.getAttribute("data-answer-value");

        answers[questionId] = value;
        selectOption(step, value);
        updateProgress(root, currentIndex, steps.length, answers);

        if (currentIndex < steps.length - 1) {
          window.setTimeout(function () {
            currentIndex += 1;
            showStep(root, steps, currentIndex, answers);
          }, 130);
          return;
        }

        resolveRecommendation(apiUrl, configUrl, flowId, answers, sessionId)
          .then(function (recommendation) {
            root.classList.add("is-complete");
            if (stepWrap) {
              stepWrap.hidden = true;
            }
            renderResult(root, recommendation, answers);
          })
          .catch(function () {
            setText(root, "[data-result-product]", "16 inch Regular Wrist Wraps");
            setText(root, "[data-result-explanation]", "Start with a versatile regular wrap for dependable support across general training.");
            if (result) {
              result.hidden = false;
            }
          });
      });
    });

    var back = root.querySelector("[data-recommender-back]");
    if (back) {
      back.addEventListener("click", function () {
        if (currentIndex === 0) {
          return;
        }
        currentIndex -= 1;
        showStep(root, steps, currentIndex, answers);
      });
    }

    var restart = root.querySelector("[data-recommender-restart]");
    if (restart) {
      restart.addEventListener("click", function () {
        answers = {};
        currentIndex = 0;
        root.classList.remove("is-complete");
        root.classList.add("is-started");
        root.classList.remove("is-waiting-to-start");
        root.querySelectorAll("[data-answer-option]").forEach(function (button) {
          button.classList.remove("is-selected");
          button.setAttribute("aria-pressed", "false");
        });
        if (stepWrap) {
          stepWrap.hidden = false;
        }
        if (result) {
          result.hidden = true;
          result.setAttribute("aria-hidden", "true");
        }
        resetDiscountForm(root);
        showStep(root, steps, currentIndex, answers);
      });
    }
  }

  function init(context) {
    var scope = context || document;
    scope.querySelectorAll("[data-tuff-recommender]").forEach(initFinder);
  }

  window.TUFFRecommendationEngine = {
    loadConfig: loadConfig,
    loadServerRecommendation: loadServerRecommendation,
    resolveRecommendation: resolveRecommendation,
    recommend: recommend,
    scoreAnswers: function (config, flowId, answers) {
      return scoreAnswers(getFlow(config, flowId), answers, flowId);
    },
    scoreRecommendation: scoreRecommendation,
    ruleMatches: ruleMatches
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
